// extracted by mini-css-extract-plugin
export default {"container":"MobileWarning_container__UNMCB","links":"MobileWarning_links__eLp9J","closeButton":"MobileWarning_closeButton__tn9aQ","imageLink":"MobileWarning_imageLink__tGjpp"};